module.exports = __webpack_public_path__ + "static/media/B2.ba9a52b4.png";


//////////////////
// WEBPACK FOOTER
// ./public/img/B2.png
// module id = 881
// module chunks = 0